export const novedades = [
  {
    h2: "Atención personalizada",
    p: "Asesoría individual, conforme a tus necesidades específicas. El residente especialista de área te apoyará siempre que lo desees. Ajustamos tu preparación conforme tu desempeño.",
    selected: false
  },
  {
    h2: "Simulador con cientos de nuevas preguntas",
    p: "Encuentra un simulador para cada una de las especialidades, que se actualizan continuamente con cientos de casos clínicos nuevos a tu simulador basados 100% en preguntas de versiones anteriores vistos en el ENARM.",
    selected: false
  },
  {
    h2: "Curso inglés médico",
    p: "Tenemos para ti un curso que te mostrará la terminología médica en el lenguaje inglés, con las preguntas más frecuentes que encontrarás en tu ENARM.",
    selected: false
  },
  {
    h2: "Todas las especialidades actualizadas",
    p: "Dentro de tu plataforma encontrarás el contenido y todas las actualizaciones de cada uno de los temas que se valoran en cada una de las especialidades.",
    selected: false
  },
  {
    h2: "Metodología de estudio",
    p: "Nuestra metodología de estudio es una de las más efectiva, con la cual miles de alumnos han podido llevar a cabo su ENARM y lograr ser residentes a la primera.",
    selected: false
  },
  {
    h2: "Simulador Pro 2026",
    p: "Experimenta la experiencia más parecida al ENARM con el mismo formato y tiempo cronometrado con más eficacia para practicar antes de tu ENARM.",
    selected: false
  },
  {
    h2: "Nuevo contenido 2026",
    p: "Disfruta de la más amplia cobertura de información que tenemos para ti.",
    selected: false
  }
];

export const stats = [
  { value: "29", name: "ESPECIALIDADES" },
  { value: "360", name: "MINI RESÚMENES" },
  { value: "2800", name: "FLASH CARDS" },
  { value: "1500", name: "HORAS DE VIDEO" },
  { value: "400", name: "RESÚMENES" },
  { value: "83%", name: "PORCENTAJE DE ACEPTACION REAL" }
];

export const blogPageTitle = ["Orientación", "sobre", "el", "ENARM", "y", "sus", "tendencias."];

export const entries = [
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
  {
    date: "25/02/2021",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet"
  },
]; 

const LandingConstants = {
  novedades,
  stats
}

export default LandingConstants;